module.exports = __webpack_public_path__ + "static/ban.00e30939.jpg";